module.exports = __webpack_public_path__ + "1eba2741c803c3c68ae6f651439e1c66.svg";